import TableCell from "@mui/material/TableCell";
import { Column } from "src/api/types";
import SortableLabel from "./components/SortableLabel";

interface Props<T> {
  column: Column<T>;
  color?: string | null;
  default_sort?: string;
}

function TableHeaderCell<T>({ column, color, default_sort }: Props<T>) {
  return (
    <TableCell
      align={column.align}
      padding="none"
      sortDirection={undefined}
      style={{
        minWidth: column.minWidth,
        fontWeight: "bolder",
        backgroundColor: color != null ? color : "",
      }}
    >
      {column.orderable ? (
        <SortableLabel column={column} default_sort={default_sort} />
      ) : (
        column.label
      )}
    </TableCell>
  );
}

export default TableHeaderCell;
